import { LoginRepository } from "@/domain/repository/login-repository";
import { CacheInvalidator } from "@/utils/cache/cache-invalidator";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LogoutUsecase {
  //MARK:- init
  constructor(
    private readonly loginRepo: LoginRepository,
    private readonly patientListCache?: CacheInvalidator
  ) {}

  //MARK: - execute
  async execute(): Promise<SATResult<void, SATError>> {
    const result = await this.loginRepo.logout();
    // 로그아웃 API 성공 여부와 무관하게 통신 암복호화에 사용되는 세션 키(AES_KEY)를 시큐어 스토리지에서 삭제
    await this.loginRepo.clearSecureSession();
    // 같은 탭에서 다른 계정으로 로그인해도 이전 계정의 환자 목록이 보이지 않도록 캐시 삭제
    this.patientListCache?.invalidate();

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    console.log("[LogoutUsecase] :: execute :: 로그아웃 성공");
    return SATResult.success(undefined);
  }
}
